/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import GreyLogo from '@/assets/svgs/grey-logo.svg';
import { greys40 } from '@/components/common/palette';

interface Props {
  haveRightBorder: boolean;
}
export const Index: React.FC<Props> = ({ haveRightBorder, ...props }) => {
  const { t } = useTranslation();
  return (
    <div {...props}>
      <span
        css={css`
          color: ${greys40};
        `}
      >
        {t('term.poweredBy')}
      </span>
      <span
        css={css`
          width: 100px;
          height: 18px;
          margin-left: 8px;
          margin-right: 8px;
          padding-right: 8px;
          vertical-align: middle;
          background-repeat: no-repeat;
          background-position: right;
          border-right: ${haveRightBorder ? `1px solid ${greys40}` : 'none'};
        `}
      >
        <GreyLogo />
      </span>
    </div>
  );
};

export default Index;
